import { useLoadScript, LoadScriptProps } from "@react-google-maps/api";
import { createContext, PropsWithChildren } from "react";
import { googleConfig } from "~/configs/googleConfig";

const GOOGLE_LIBRARIES: LoadScriptProps["libraries"] = ["places"];

interface GoogleContextData {
  isLoaded: boolean;
}

const GoogleContext = createContext<GoogleContextData>({
  isLoaded: false,
});

export const GoogleContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: googleConfig.ApiKey,
    libraries: GOOGLE_LIBRARIES,
    version: "weekly",
  });

  return (
    <GoogleContext.Provider
      value={{
        isLoaded,
      }}
    >
      {children}
    </GoogleContext.Provider>
  );
};

export default GoogleContext;
